export const ErrorCodes = {
  PRODUCT_OUT_OF_STOCK: 'PRODUCT_OUT_OF_STOCK',
  PRODUCT_BRANCH_INVALID: 'PRODUCT_BRANCH_INVALID',
  PRODUCT_INACTIVE: 'PRODUCT_INACTIVE',
  PACKAGE_NOT_STARTED: 'PACKAGE_NOT_STARTED',
  PACKAGE_INACTIVE: 'PACKAGE_INACTIVE',
  PACKAGE_EXPIRED: 'PACKAGE_EXPIRED',
  PACKAGE_BRANCH_INVALID: 'PACKAGE_BRANCH_INVALID',
  PACKAGE_LIMIT_EXCEEDED: 'PACKAGE_LIMIT_EXCEEDED',
  PACKAGE_USER_LIMIT_EXCEEDED: 'PACKAGE_USER_LIMIT_EXCEEDED',
  PACKAGE_USER_DAILY_LIMIT_EXCEEDED: 'PACKAGE_USER_DAILY_LIMIT_EXCEEDED',
  PACKAGE_USER_MONTHLY_LIMIT_EXCEEDED: 'PACKAGE_USER_MONTHLY_LIMIT_EXCEEDED',
  PACKAGE_USER_MONTHLY_USE_LIMIT_EXCEEDED: 'PACKAGE_USER_MONTHLY_USE_LIMIT_EXCEEDED',
  PROMOTION_INACTIVE: 'PROMOTION_INACTIVE',
  PROMOTION_NOT_STARTED: 'PROMOTION_NOT_STARTED',
  PROMOTION_EXPIRED: 'PROMOTION_EXPIRED',
  PROMOTION_BRANCH_INVALID: 'PROMOTION_BRANCH_INVALID',
  INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
  TOKEN_EXPIRED: 'TOKEN_EXPIRED',
  INVALID_TOKEN: 'INVALID_TOKEN',
  UPLOAD_LIST_PHONE_FORMAT_INVALID: 'UPLOAD_LIST_PHONE_FORMAT_INVALID',
  UPLOAD_LIST_PHONES_EXISTING: 'UPLOAD_LIST_PHONES_EXISTING',
  UPLOAD_LIST_DUPLICATE_PHONES: 'UPLOAD_LIST_DUPLICATE_PHONES',
  MANY_TIERS: 'MANY_TIERS',
  GROUP_NOT_FOUND: 'GROUP_NOT_FOUND',
  TIER_NOT_FOUND: 'TIER_NOT_FOUND',
  GROUP_NAME_ALREADY_EXISTS: 'GROUP_NAME_ALREADY_EXISTS',
  GROUP_MINIMUM_POINT_ALREADY_EXISTS: 'GROUP_MINIMUM_POINT_ALREADY_EXISTS',
  SHOP_USER_NOT_FOUND: 'SHOP_USER_NOT_FOUND',
  CATEGORY_NOT_FOUND: 'CATEGORY_NOT_FOUND',
  CATEGORY_EXISTING: 'CATEGORY_EXISTING',
  PRODUCT_NOT_FOUND: 'PRODUCT_NOT_FOUND',
  VARIANT_NOT_FOUND: 'VARIANT_NOT_FOUND',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  PROMOTION_NOT_FOUND: 'PROMOTION_NOT_FOUND',
  ADD_ON_NOT_FOUND: 'ADD_ON_NOT_FOUND',
  ADD_ON_GROUP_NOT_FOUND: 'ADD_ON_GROUP_NOT_FOUND',
  PACKAGE_NOT_FOUND: 'PACKAGE_NOT_FOUND',
  COUPON_NOT_FOUND: 'COUPON_NOT_FOUND',
  ORDER_NOT_FOUND: 'ORDER_NOT_FOUND',
  SHOP_PRODUCT_SKU_ALREADY_EXISTS: 'SHOP_PRODUCT_SKU_ALREADY_EXISTS',
  VARIANT_SKU_DUPLICATE_IN_PRODUCT: 'VARIANT_SKU_DUPLICATE_IN_PRODUCT',
  DEPOSIT_PRODUCT_CODE_ALREADY_EXISTS: 'DEPOSIT_PRODUCT_CODE_ALREADY_EXISTS',
  COUPON_BOTH_CODE_EXIST: 'COUPON_BOTH_CODE_EXIST',
  COUPON_CODE_REQUIRED: 'COUPON_CODE_REQUIRED',
  COUPON_DISCOUNT_REQUIRED: 'COUPON_DISCOUNT_REQUIRED',
  COUPON_BOTH_DISCOUNT_EXIST: 'COUPON_BOTH_DISCOUNT_EXIST',
  COUPON_NAME_TOO_LONG: 'COUPON_NAME_TOO_LONG',
  PRODUCT_SKU_NOT_FOUND: 'PRODUCT_SKU_NOT_FOUND',
  SHOP_BRANCH_NOT_FOUND: 'SHOP_BRANCH_NOT_FOUND',
  SHOP_BRANCH_LIMIT_REACHED: 'SHOP_BRANCH_LIMIT_REACHED',
  DEPOSIT_PRODUCT_NOT_FOUND: 'DEPOSIT_PRODUCT_NOT_FOUND',
  INVALID_STOCK_VALUE: 'INVALID_STOCK_VALUE',
  COUPON_MULTICODE_LIMIT_EXCEEDED: 'COUPON_MULTICODE_LIMIT_EXCEEDED',
  COUPON_INACTIVE: 'COUPON_INACTIVE',
  COUPON_CODE_UNAVAILABLE: 'COUPON_CODE_UNAVAILABLE',
  COUPON_CODE_INVALID: 'COUPON_CODE_INVALID',
  COUPON_NOT_STARTED: 'COUPON_NOT_STARTED',
  COUPON_EXPIRED: 'COUPON_EXPIRED',
  COUPON_LIMIT_EXCEEDED: 'COUPON_LIMIT_EXCEEDED',
  COUPON_DAILY_LIMIT_EXCEEDED: 'COUPON_DAILY_LIMIT_EXCEEDED',
  COUPON_USER_LIMIT_EXCEEDED: 'COUPON_USER_LIMIT_EXCEEDED',
  COUPON_USER_MONTHLY_LIMIT_EXCEEDED: 'COUPON_USER_MONTHLY_LIMIT_EXCEEDED',
  COUPON_USER_MONTHLY_USE_LIMIT_EXCEEDED: 'COUPON_USER_MONTHLY_USE_LIMIT_EXCEEDED',
  POINT_INSUFFICIENT: 'POINT_INSUFFICIENT',
  WALLET_INSUFFICIENT: 'WALLET_INSUFFICIENT',
  POINT_PAYMENT_NOT_ENABLED: 'POINT_PAYMENT_NOT_ENABLED',
  WALLET_PAYMENT_NOT_ENABLED: 'WALLET_PAYMENT_NOT_ENABLED',
  PAYMENT_AMOUNT_NOT_STEP_ALIGNED: 'PAYMENT_AMOUNT_NOT_STEP_ALIGNED',
  PAYMENT_EXCEEDS_TOTAL: 'PAYMENT_EXCEEDS_TOTAL',
  POINT_PAYMENT_LIMIT_EXCEEDED: 'POINT_PAYMENT_LIMIT_EXCEEDED',
  WALLET_PAYMENT_LIMIT_EXCEEDED: 'WALLET_PAYMENT_LIMIT_EXCEEDED',
  PAYMENT_BALANCE_CHANGED: 'PAYMENT_BALANCE_CHANGED',
  STOCK_RESULT_NEGATIVE: 'STOCK_RESULT_NEGATIVE',
  POINT_RESULT_NEGATIVE: 'POINT_RESULT_NEGATIVE',
  TEST: 'TEST',
  INSUFFICIENT_CREDIT_BALANCE: 'INSUFFICIENT_CREDIT_BALANCE',
  NEGATIVE_POINT_EXCEEDS_BALANCE: 'NEGATIVE_POINT_EXCEEDS_BALANCE',
  INSUFFICIENT_AI_CREDITS: 'INSUFFICIENT_AI_CREDITS',
  SLIP_AMOUNT_MISMATCH: 'SLIP_AMOUNT_MISMATCH',
  SLIP_ACCOUNT_MISMATCH: 'SLIP_ACCOUNT_MISMATCH',
  SLIP_VERIFICATION_FAILED: 'SLIP_VERIFICATION_FAILED',
  INSUFFICIENT_POINT_BALANCE: 'INSUFFICIENT_POINT_BALANCE',
  COUPON_ALREADY_USED: 'COUPON_ALREADY_USED',
  CUSTOMER_PACKAGE_NOT_FOUND: 'CUSTOMER_PACKAGE_NOT_FOUND',
  CUSTOMER_DELETED_CANNOT_USE_PACKAGE: 'CUSTOMER_DELETED_CANNOT_USE_PACKAGE',
  PACKAGE_REDEEM_NOT_ALLOWED: 'PACKAGE_REDEEM_NOT_ALLOWED',
  PACKAGE_DAILY_USE_LIMIT_EXCEEDED: 'PACKAGE_DAILY_USE_LIMIT_EXCEEDED',
  PACKAGE_USE_LIMIT_EXCEEDED: 'PACKAGE_USE_LIMIT_EXCEEDED'
};
